import { useCallback } from 'react';

import { useFormContext } from 'react-hook-form';

import { isDefined } from '@hsp/utilities';

import { SearchType } from '@t/api/audience/enums/search-type.enum';

const formName = `${SearchType.Attributes}.excludeBusiness`;

export const useExcludeBusinessConfig = () => {
  const { getValues, setValue } = useFormContext();

  const getToggleValue = useCallback(() => {
    const formValues = getValues(formName);

    if (isDefined(formValues)) {
      const { value } = formValues;

      return value;
    }

    return '0';
  }, [getValues]);

  return {
    formName,
    getToggleValue,
    getValues,
    setValue,
  };
};
